import { File02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";
import { Button, ButtonSize, ButtonVariant, Show } from "shared/components";

export const NoRowsFallback = ({
  Icon,
  iconStrokeWidth,
  title = "No data",
  text = "There are no rows to display.",
  buttonText,
  buttonAction
}: {
  Icon?: IconSvgElement;
  iconStrokeWidth?: number;
  title?: string;
  text?: string | null;
  buttonText?: string;
  buttonAction?: () => void;
}) => {
  return (
    <div className="col-span-full flex h-full flex-col items-center justify-center py-20">
      <div className="mb-6 flex items-center justify-center rounded-full bg-alpha-40 p-8">
        {Icon ? (
          <HugeiconsIcon
            icon={Icon as IconSvgElement}
            size={40}
            strokeWidth={iconStrokeWidth}
            className="text-content-1000"
          />
        ) : (
          <HugeiconsIcon
            icon={File02Icon}
            size={40}
            strokeWidth={iconStrokeWidth}
            className="text-content-1000"
          />
        )}
      </div>
      <p className="mb-2 text-base font-bold text-content-500">{title}</p>
      <Show if={Boolean(text)}>
        <p className="text-sm font-medium text-content-300 text-center">
          {text}
        </p>
      </Show>
      {buttonText && buttonAction ? (
        <Button
          onClick={() => {
            buttonAction();
          }}
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.SM}
          className="mt-6"
        >
          {buttonText}
        </Button>
      ) : null}
    </div>
  );
};
